<template>
  <div class="ui-upload" style="position:relative" :id="id">
    <div class="--label" v-if="label">
      {{ label }}
    </div>
    <input
      v-if="resetFile"
      type="file"
      ref="uploader"
      v-bind="$attrs"
      multiple
      @change="previewFiles"
      v-show="false"
    />
    <slot :opener="handleOpen" :isLoading="loading" :uploadedFile="value">
      <v-icon
        v-if="mode == 'icon'"
        :color="value ? 'primary' : ''"
        @click="handleOpen"
      >
        {{ value ? 'mdi-upload' : 'mdi-upload-outline' }}</v-icon
      >
      <div
        v-else
        @click="handleOpen"
        class="imgbox opener dropbox"
        :style="imgboxStyle"
      ></div>
    </slot>
    <VueQrcode
      :id="id + `_qrcode`"
      :value="qrcode"
      v-if="showQRCode"
      :style="{
        width: '150px',
        height: '150px',
        position: 'absolute',
        top: '0px',
        left: '0px',
      }"
    />
    <Popover :targetId="id" on="contextmenu">
      <template>
        <div
          v-for="(item, idx) in opts"
          :key="idx"
          class="ui-dropdown--item popover-close"
          @click="handleItemClick(item)"
        >
          <div class="ui-dropdown--item-inner">
            {{ item.text }}
          </div>
        </div>
      </template>
    </Popover>
  </div>
</template>

<script>
import Popover from '@/components/Forms/Popover'
import VueQrcode from 'vue-qrcode'

//import Vue from "vue";

export default {
  components: {
    Popover,
    VueQrcode,
  },
  data: () => ({
    files: [],
    id: 'upload',
    uploadedFile: null,
    loading: false,
    showQRCode: false,
    resetFile: 1,
  }),
  props: {
    label: String,
    value: String,
    mode: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    qrcode() {
      return (
        window.location.protocol +
        '//' +
        window.location.host.replace(':8000', ':8001') +
        '/Main/App/Extender?clientKey=' +
        window.ClientKey +
        '&cmd=upload'
      )
    },
    opts() {
      if (this.showQRCode) return [{ text: 'Cancel' }]
      else if (this.value)
        return [{ text: 'Mobile Upload' }, { text: 'View' }, { text: 'Clear' }]
      else if (this.disabled) return [{ text: 'View' }]
      else return [{ text: 'Mobile Upload' }]
    },
    imgboxStyle() {
      if (this.loading) {
        return {
          'background-image': 'url(/img/icons/loading.gif)',
        }
      } else if (!this.value) {
        return {
          'background-image': 'url(/img/icons/camera.png)',
        }
      } else {
        let ext = this.value.substr(-4).replace('.', '')
        if (
          ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)
        ) {
          return {
            'background-image': 'url(/img/icons/' + ext + '-icon.png)',
          }
        } else if (['jpg', 'jpeg', 'png'].includes(ext)) {
          return {
            'background-image':
              'url(' +
              this.$api.url +
              this.value.replace('/ori/', '/small/') +
              ')',
            'background-size': 'cover',
          }
        }
        return {
          'background-image': 'url(' + this.$api.url + this.value + ')',
          'background-size': 'cover',
        }
      }
    },
  },
  watch: {
    value() {
      // console.log(val)
    },
  },
  created() {
    if (!window.uuid) window.uuid = 0
    this.id = 'upload-' + window.uuid++
  },
  methods: {
    handleOpen() {
      if (!this.disabled) this.$refs.uploader.click()
    },
    async previewFiles(event) {
      var form = new FormData()
      this.loading = true
      form.append('file', event.target.files[0])
      let res = await this.$api.upload(form)
      if (res.success) {
        this.uploadedFile = res.data
        this.$emit('update:value', res.data)
        this.$emit('change', res)
        this.resetFile++
      }
      this.loading = false
    },
    handleItemClick(item) {
      if (item.text == 'Mobile Upload') {
        this.showQRCode = true
        if (this.$options.sockets.onmessage)
          delete this.$options.sockets.onmessage
        this.$options.sockets.onmessage = evt => {
          let d = JSON.parse(evt.data)
          if (d.clientKey == window.ClientKey && this.showQRCode) {
            this.$emit('update:value', d.value)
            this.$emit('change', d)
            this.resetFile++
            this.showQRCode = false
          }
        }
      } else if (item.text == 'View') {
        if (this.value)
          window.open(
            this.$api.url + this.value.replace(/^tmp\//, '/reports/get/'),
            '_blank'
          )
      } else if (item.text == 'Cancel') {
        if (this.$options.sockets.onmessage)
          delete this.$options.sockets.onmessage
        this.showQRCode = false
      } else if (item.text == 'Clear') {
        this.$emit('update:value', '')
      }
    },
  },
}
</script>
<style lang="scss">
.ui-upload {
  width: 150px;
  display: inline-block;
  .--label {
    padding: 10px;
    white-space: nowrap;
    background: rgb(243, 243, 243);
    width: 100%;
    display: flex;
    font-size: small;
  }
  .upload-image {
    width: 200px;
    height: 200px;
    background-color: #f3f3f3;
    background-position: center;
    background-repeat: no-repeat;
  }
  .opener.dropbox {
    background-position: 50%;
  }
  .imgbox {
    width: 150px;
    max-width: 100%;
    height: 150px;
    max-height: 100%;
    background: silver;
    border-right: 1px solid white;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;

    &.empty {
      background-image: url('/img/icons/camera.png');
      background-size: initial;
    }
  }
  .ui-popover {
    border: 1px solid silver;
    max-height: 200px;
    overflow: auto;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
    .ui-dropdown--item {
      padding: 0 8px;
      cursor: pointer;
      &-inner {
        padding: 5px 0;
        border-bottom: 1px solid #ddd;
        text-align: left;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:last-child {
        .ui-dropdown--item-inner {
          border-bottom-color: transparent;
        }
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
